import { render } from "./MatchLoadouts.vue?vue&type=template&id=08863ef6&scoped=true"
import script from "./MatchLoadouts.vue?vue&type=script&lang=js"
export * from "./MatchLoadouts.vue?vue&type=script&lang=js"

import "./MatchLoadouts.vue?vue&type=style&index=0&id=08863ef6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08863ef6"]])

export default __exports__